import { Link } from "react-router-dom";

export const ShortcutCard = ({
  to,
  search,
  onClick,
  icon: Icon,
  label,
  disabled = false,
  active = false,
  badge,
  layout = "default",
  title,
}) => {
  const cardClass = [
    "valut-shortcut-card",
    layout === "extract" ? "valut-shortcut-card--extract" : "",
    active ? "valut-shortcut-card-active" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const content = layout === "extract" ? (
    <>
      {badge ? <span className="extract-shortcut-badge">{badge}</span> : null}
      <Icon
        className={`extract-shortcut-icon ${disabled ? "text-gray-400" : "text-[#242424] dark:text-gray-100"}`}
      />
      <span className={`extract-shortcut-label ${disabled ? "text-gray-400" : ""}`}>
        {label}
      </span>
    </>
  ) : (
    <>
      {badge && <span className="shortcut-badge">{badge}</span>}
      <Icon
        className={`shortcut-icon ${
          disabled ? "text-gray-400" : "text-[#242424] dark:text-gray-100"
        }`}
      />
      <span className={`shortcut-label ${disabled ? "text-gray-400" : ""}`}>{label}</span>
    </>
  );

  if (disabled) {
    return (
      <div
        className="valut-shortcut-card valut-shortcut-card-disabled"
        aria-disabled="true"
        title={title}
      >
        {content}
      </div>
    );
  }

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cardClass}
        aria-pressed={active}
        title={title}
      >
        {content}
      </button>
    );
  }

  return (
    <Link
      to={search ? { pathname: to, search } : to}
      className={`link-no-zoom ${cardClass}`}
      title={title}
    >
      {content}
    </Link>
  );
};
